import { render } from "./CompanyAccount-Indemnitor-Progress.vue?vue&type=template&id=115cd3a5&scoped=true"
import script from "./CompanyAccount-Indemnitor-Progress.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-Indemnitor-Progress.vue?vue&type=script&lang=js"

import "./CompanyAccount-Indemnitor-Progress.vue?vue&type=style&index=0&id=115cd3a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115cd3a5"]])

export default __exports__